import { PurchaseOrderStatus } from '../constants/purchase-order-status.js';
/** Statuses that represent an active commitment to a vendor (excludes Draft). */
export const PURCHASE_ORDER_OPEN_STATUS_IDS = [
    PurchaseOrderStatus.ISSUED,
    PurchaseOrderStatus.SHIPPED,
    PurchaseOrderStatus.PARTIALLY_RECEIVED,
];
//# sourceMappingURL=purchase-order-open-status-ids.js.map